import { defineComponent, h } from 'vue';
import { createdAt } from '@/ui/components/activityLogs/common/CreatedAt';
import { ActivityComment } from '@/entities/activity/model';

interface CommentProps {
  log: ActivityComment;
}

export const Comment = defineComponent<CommentProps>({
  name: 'Comment',
  props: ['log'],
  setup(props) {
    return function render() {
      return h('div', { class: 'activity-logs__log' }, [
        createdAt({ props: { log: props.log } },
          [
            h('strong', { slot: 'left', class: 'activity-logs__created-at--author-comment' }, props.log.user?.name),
          ]),
        h('div', { class: 'activity-logs__log-comment' }, [
          props.log.payload.comment,
        ]),
      ]);
    };
  },
});
